import Vue from "vue";
import Vuex from "vuex";
import {
    ANSWER,
    ANSWER_MEMBER,
    GET_RELATE_INFO,
    GET_POLICY_LIST,
    UPDATE_POLICY,
    DELETE_POLICY,
    SAVE_POLICY,
} from "./mutation-types.js";
import { SELF, MATE, CHILD } from "../../../enum/RELATION.js";
import { MALE, FEMALE } from "../../../enum/GENDER.js";
import http from "../h5-network/request.js";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        answer: {
            gender: "",
            name: "",
            member: [
                /**
                 * {
                 *   relation: Number,    // 和测评人的关系
                 *   gender: Number,    // 性别
                 *   age: Number,     // 年龄
                 *   income: Number,  // 收入
                 *   checked: Boolean, // 选中的成员
                 * }
                 */
                {
                    relation: SELF, // 和测评人的关系
                    gender: "", // 性别
                    age: "", // 年龄
                    income: "", // 收入
                    checked: true,
                },
                {
                    relation: MATE, // 和测评人的关系
                    gender: "", // 性别
                    age: "", // 年龄
                    income: "", // 收入
                    checked: false,
                },
                {
                    relation: CHILD, // 和测评人的关系
                    gender: MALE, // 性别
                    age: "", // 年龄
                    checked: false,
                },
                {
                    relation: CHILD, // 和测评人的关系
                    gender: FEMALE, // 性别
                    age: "", // 年龄
                    checked: false,
                },
            ],
            city: "北京市-市辖区",
            cityCode: "1101",
            complete: 0,
            questionNumber: 0,
        },
        policyList: [], //其他公司保单集合
        relateInfo: {},
    },
    getters: {
        [GET_RELATE_INFO](state) {
            return state.relateInfo;
        },
        [GET_POLICY_LIST](state) {
            return state.policyList;
        },
    },
    mutations: {
        [ANSWER](state, { idx, value }) {
            Vue.set(state.answer, idx, value);
            // 修改性别的时候，同步成员内本人和配偶的性别
            if (idx === "gender") {
                const selfMember = state.answer.member.find(
                    (item) => item.relation == SELF
                );
                const mateMember = state.answer.member.find(
                    (item) => item.relation == MATE
                );
                selfMember.gender = value;
                mateMember.gender = value == MALE ? FEMALE : MALE;
            }
        },
        [ANSWER_MEMBER](state, { type, index, idx, value }) {
            if (type == "update") {
                state.answer.member[index][idx] = value;
            }
            if (type == "add") {
                state.answer.member.push(value);
            }
        },
        [GET_RELATE_INFO](state, param) {
            state.relateInfo = param;
        },
        //添加其他公司保单
        [GET_POLICY_LIST](state, param) {
            state.policyList = param;
        },
    },
    actions: {
        [GET_RELATE_INFO]({ commit }) {
            return http({
                loading: true,
                url: "/bdzb-core-service/member/isRelateInsurance",
                data: {},
                method: "POST",
            }).then((res) => {
                commit(GET_RELATE_INFO, res);
                return res;
            });
        },
        //添加其他公司保单
        [GET_POLICY_LIST]({ commit }, param) {
            return http({
                loading: true,
                url: "/bdzb-core-service/policy/lists",
                data: param,
                method: "POST",
            }).then((res) => {
                console.log(res, "------GET_POLICY_LIST");
                commit(GET_POLICY_LIST, res);
                return res;
            });
        },
        [SAVE_POLICY](state, param) {
            return http({
                loading: true,
                url: "/bdzb-core-service/policy/save",
                data: param,
                method: "POST",
            }).then((rep) => {
                return rep;
            });
        },
        [UPDATE_POLICY](state, param) {
            return http({
                loading: true,
                url: "/bdzb-core-service/policy/update",
                data: param,
                method: "POST",
            }).then((rep) => {
                return rep;
            });
        },
        [DELETE_POLICY](state, param) {
            return http({
                loading: true,
                url: "/bdzb-core-service/policy/del",
                data: param,
                method: "POST",
            }).then((rep) => {
                return rep;
            });
        },
    },
});
